import { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useRecoilState } from "recoil";
import { ErrorToast, SuccessToast, WarningToast } from "../Admin/Components/ToastComponent/RectHotToast";
import { ClearSpecificForm } from "../Store/FormDataReducer/FormFieldFunctions";
import pathState from "../atoms/pathstate";
import { replaceUnderscore } from "./common";
import { useSelector } from "react-redux";

// For Brief Understanding Read MD Docs in formcomponents
const useSubmitOperation = () => {
  const dispatch = useDispatch();
  const [{ CurrentTitle }] = useRecoilState(pathState);

  const [operationLoading, setOperationLoading] = useState(false);
  let Refetch = useSelector((store) => store?.FormFieldData.refresh);

  const executeOperation = useCallback(
    async ({
      operationType,
      data,
      selectedRows,
      Mutation,
      processDataBeforeSubmit,
      variableName = "input", // Default variable name for create and edit operations
      idField = "_id", // Default ID field name for edit and delete operations
      EditRefresh = true,
      PageName = "Record",
      OnSuccess = (res) => { },
    }) => {
      setOperationLoading(true);
      console.log(data, "YYYYYYYYYYYYYYYY");
      // Process data if a processing function is provided
      const processedData = processDataBeforeSubmit ? processDataBeforeSubmit(data) : data;
      try {
        let variables = {};
        switch (operationType) {
          case "Add":
            variables[variableName] = processedData;
            delete data?.["Upload Image"];
            console.log(variables, "variablesvariables2");
            await Mutation({ variables }).then((res) => {
              SuccessToast(`${replaceUnderscore(PageName)} Created Successful`);
              if (CurrentTitle === PageName) {
                dispatch({ type: "Refetch", payload: true });
              }
              if (OnSuccess);
              {
                OnSuccess(res);
              }
            });

            break;
          case "Edit":
            console.log(Mutation);
            // debugger;
            variables = {
              id: processedData[idField],
              [variableName]: processedData,
            };
            await Mutation({ variables }).then((res) => {
              SuccessToast(`${replaceUnderscore(PageName)} Edited Successful`);

              if (EditRefresh) {
                if (CurrentTitle === PageName) {
                  dispatch({ type: "Refetch", payload: !Refetch });
                }
              }
              if (OnSuccess);
              {
                OnSuccess(res);
              }
            });
            break;
          case "Delete":
            const idsToDelete = selectedRows.map((row) => row[idField]);
            //To handle the backend message
            await Mutation({ variables: { idsToDelete } })
              .then((res) => {
                const Key = Object.keys(res.data)[0] || "";
                const message = res?.data?.[Key]?.message || `${replaceUnderscore(PageName)} Deleted Successfully`;
                SuccessToast(message);
              })
              .catch((error) => {
                console.error("Error during mutation:", error);
                ErrorToast("An error occurred while deleting. Please try again.");
              });
            if (CurrentTitle === PageName) {
              dispatch({ type: "Refetch", payload: true });
            }
            break;
          case "Lock":
            await Mutation().then((res) => {
              dispatch({ type: "Refetch", payload: true });
              const { message } = Object.values(res?.data)[0];
              SuccessToast(message);
            });
            break;
          case "Unlock":
            await Mutation().then((res) => {
              dispatch({ type: "Refetch", payload: true });
              const { message } = Object.values(res?.data)[0];
              SuccessToast(message);
            });
            break;
          case "Merge":
            // Directly use `data` as it should already contain `existingId` and `newId`
            await Mutation({
              variables: {
                existingId: data.existingId,
                newId: data.newId,
              },
            });
            SuccessToast(`${replaceUnderscore(PageName)} Successfully`);
            dispatch({ type: "Refetch", payload: true });
            break;
          default:
            throw new Error("Invalid operation type");
        }
      } catch (error) {
        console.log(error.message);
        ErrorToast(error.message);
        throw error;
      } finally {
        setOperationLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );
  return { executeOperation, operationLoading };
};
export default useSubmitOperation;

// ------------------------------------------------------------------------------
// For Brief Understanding Read MD Docs in formcomponents
export const mergeAllDataIntoFormData = (allData) => {
  let formData = {};
  for (let key in allData) {
    formData = {
      ...formData,
      ...allData[key],
    };
  }
  return formData;
};

// ---------------------------------------------------------------------------------
// For Brief Understanding Read MD Docs in formcomponents
export const usePrepareGraphQLVariables = (
  operationType,
  allFieldsData,
  formData,
  selectedRows,
  createVariableKey = "createInput", // Default key for create operations
  editVariableKey = "userInput", // Default key for edit operations
  mergeVariableKeys = { existingIdKey: "existingId", newIdKey: "newId" }, // Default keys for merge operations
  deleteVariableKey = "idsToDelete"
) => {
  const variables = useMemo(() => {
    let variablesObj = {}; // Initialize the variables object
    // Determine the correct ID key for Edit operation
    const idKey = allFieldsData && allFieldsData._id ? "_id" : allFieldsData && allFieldsData.id ? "id" : null;
    const id = idKey ? allFieldsData[idKey] : undefined;
    console.log(id);
    switch (operationType) {
      case "Edit":
        if (id) {
          console.log(formData);
          variablesObj = { id, [editVariableKey]: formData };
          console.log(variablesObj);
        }
        break;
      case "Delete":
        // console.log("Yasim");
        // Use the logic to accommodate both _id and id
        const idsToDelete = selectedRows?.map((obj) => obj?._id || obj?.id);
        console.log(selectedRows, idsToDelete, "idsToDelete");
        if (idsToDelete?.length > 0) {
          variablesObj = { [deleteVariableKey]: idsToDelete };
        }
        break;
      case "Merge":
        const existingIdValue = formData[mergeVariableKeys.existingIdKey];
        const newIdValue = formData[mergeVariableKeys.newIdKey] || formData["newId"];
        if (existingIdValue && newIdValue) {
          variablesObj = { existingId: existingIdValue, newId: newIdValue };
        }
        break;
      case "Add":
        variablesObj = { [createVariableKey]: formData };
        break;
      case "Lock":
        const idsToLock = [];
        if (selectedRows?.length > 0) {
          selectedRows.forEach((doc) => {
            if (!doc.Is_Lock) {
              idsToLock.push(doc._id);
            }
          });
        }

        // const idsToUpdate = selectedRows?.map((obj) => obj?._id || obj?.id);
        variablesObj = { idsToUpdate: idsToLock, Is_Lock: true };
        break;
      case "Unlock":
        const idsToUnLock = [];

        if (selectedRows?.length > 0) {
          selectedRows.forEach((doc) => {
            if (doc.Is_Lock) {
              idsToUnLock.push(doc._id);
            }
          });
        }

        // const idsToUnlock = selectedRows?.map((obj) => obj?._id || obj?.id);
        variablesObj = { idsToUpdate: idsToUnLock, Is_Lock: false };
        break;
      default:
        console.error("Unsupported operation type.");
        break;
    }
    console.log(variablesObj, operationType);
    return variablesObj;
  }, [
    operationType,
    allFieldsData,
    formData,
    selectedRows,
    createVariableKey,
    editVariableKey,
    deleteVariableKey,
    mergeVariableKeys.existingIdKey,
    mergeVariableKeys.newIdKey,
  ]);

  return variables;
};

// -----------------------------------------------------------------------------------
// For Brief Understanding Read MD Docs in formcomponents
export const handleFormSubmission = (executeOperationFunction, params) => {
  const {
    dispatch,
    Form_Key,
    operationType,
    closeAction,
    onSuccess, // Optional custom success handler
    onError, // Optional custom error handler
    closeFormFunction,
    resetFormDataFunction, // For "Add" operation type
  } = params;
  console.log(executeOperationFunction);
  executeOperationFunction()
    .then((res) => {
      console.log(res, "res1");
      // Success logic
      // SuccessToast(`${operationType} operation successful`);
      if (onSuccess) onSuccess(res); // Call custom success handler if provided
      if (["Close", "Delete", "Edit"].includes(closeAction) || operationType !== "Add") {
        closeFormFunction();
      } else if (operationType === "Add" || closeAction === "Print") {
        resetFormDataFunction();
        ClearSpecificForm(dispatch, Form_Key);
      }
    })
    .catch((error) => {
      console.log(error, "res2");
      // Error logic
      // ErrorToast((error as Error).message);
      if (onError) onError(error); // Call custom error handler if provided
      if (closeAction === "Close" || closeAction === "close") {
        // closeFormFunction();
      }
    });
};

// --------------------------------------------------------------------------------
// For Brief Understanding Read MD Docs in formcomponents
export const getMutationFunction = (operationType, mutationFunctions) => {
  const { CreatingData, EditingData, DeletingData, MergingData, lockTheEntry } = mutationFunctions;
  switch (operationType) {
    case "Add":
      return CreatingData;
    case "Edit":
      return EditingData;
    case "Delete":
      return DeletingData;
    case "Merge":
      return MergingData;
    case "Lock":
      return lockTheEntry;
    case "Unlock":
      return lockTheEntry;
    default:
      throw new Error("Invalid operation type");
  }
};
